<p-card class="block mt-6">
  <div class="flex flex-column align-items-center">
    <div class="body2Font align-self-end">
      <span i18n>Submitted on </span><span>{{ fileInfo.createdDateTime | date:'y-m-d-t' }}</span>
    </div>
    <div class="title3Font"
         i18n>
      Copyright Agreement
    </div>
    <div class="body2Font mt-2"
         i18n>
      As a paper is published you can download the Agreement:
    </div>

    <div class="et-download-box">
      <sc-file-download [fileInfo]="fileInfo"
                        [download$]="download$">
      </sc-file-download>
    </div>
  </div>
</p-card>